export default __webpack_public_path__ + "static/media/2.2dd6909f.png";